import { render } from "./SubmitRules.vue?vue&type=template&id=fb2449b4"
import script from "./SubmitRules.vue?vue&type=script&lang=js"
export * from "./SubmitRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__